import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import page404 from '@/components/errorpage/page404'
import EditPwd from '@/components/EditPwd'
import YogaProductType from '@/components/yoga/YogaProductType'
import YogaInport from '@/components/yoga/YogaInport'
import YogaSale from '@/components/yoga/YogaSale'
import YogaParam from '@/components/yoga/YogaParam'
import YogaStock from '@/components/yoga/YogaStock'
import YogaStatistics from '@/components/yoga/YogaStatistics'
import SysUser from '@/components/sys/SysUser'
import SysMenu from '@/components/sys/SysMenu'
import SysRole from '@/components/sys/SysRole'
import LikeHead from '@/components/like/LikeHead'
import LoveqList from '@/components/loveq/LoveqList'
import LoveqDetail from '@/components/loveq/LoveqDetail'
import TourMap from '@/components/tour/TourMap'
import TourGroupList from '@/components/tour/TourGroupList'
import ScheduleTaskList from '@/components/schedule/ScheduleTaskList'
import TencentFirewall from '@/components/tencent/TencentFirewall'
import CarTrack from '@/components/car/CarTrack'
import GzjjAddress from '@/components/car/GzjjAddress'
import DslOpenApiSign from '@/components/dsl/DslOpenApiSign'
import DslApiGatewaySign from '@/components/dsl/DslApiGatewaySign'
import DslCreateJiraTask from '@/components/dsl/DslCreateJiraTask'

const loginpage = resolve => require(['@/components/Login'],resolve)
Vue.use(Router)

let router =  new Router({
  base: '/yoga/',
  routes:[
    {
      path: '/',
      name: 'base',
      meta: {
        title: '管理后台'
      },
      component: loginpage
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '登录页'
      },
      component: loginpage
    },
    {
      path: '/home',
      name: 'Home',
      meta: {
        title: '管理后台'
      },
      component: Home
    },
    {
      path: '*',
      name: 'page404',
      component: page404
    },
    {
      path: '/EditPwd',
      name: 'EditPwd',
      component: EditPwd
    },
    {
      path: '/yoga/YogaProductType',
      name: 'YogaProductType',
      component: YogaProductType
    },
    {
      path: '/yoga/YogaInport',
      name: 'YogaInport',
      component: YogaInport
    },
    {
      path: '/yoga/YogaSale',
      name: 'YogaSale',
      component: YogaSale
    },
    {
      path: '/yoga/YogaParam',
      name: 'YogaParam',
      component: YogaParam
    },
    {
      path: '/yoga/YogaStock',
      name: 'YogaStock',
      component: YogaStock
    },
    {
      path: '/yoga/YogaStatistics',
      name: 'YogaStatistics',
      component: YogaStatistics
    },
    {
      path: '/sys/SysUser',
      name: 'SysUser',
      component: SysUser
    },
    {
      path: '/sys/SysMenu',
      name: 'SysMenu',
      component: SysMenu
    },
    {
      path: '/sys/SysRole',
      name: 'SysRole',
      component: SysRole
    },
    {
      path: '/likeHead',
      name: 'LikeHead',
      meta: {
        title: '点赞列表'
      },
      component: LikeHead
    },
    {
      path: '/loveq/list',
      name: 'LoveqList',
      meta: {
        title: 'loveq列表'
      },
      component: LoveqList
    },
    {
      path: '/loveq/detail',
      name: 'LoveqDetail',
      meta: {
        title: 'loveq详情'
      },
      component: LoveqDetail
    },
    {
      path: '/tour/map',
      name: 'TourMap',
      meta: {
        title: '旅游列表'
      },
      component: TourMap
    },
    {
      path: '/tour/group/list',
      name: 'TourGroupList',
      meta: {
        title: '旅游列表'
      },
      component: TourGroupList
    },
    {
      path: '/schedule/task/list',
      name: 'ScheduleTaskList',
      meta: {
        title: '任务列表'
      },
      component: ScheduleTaskList
    },
    {
      path: '/tencent/firewall',
      name: 'TencentFirewall',
      meta: {
        title: '防火墙设置'
      },
      component: TencentFirewall
    },
    {
      path: '/car/carTrack',
      name: 'CarTrack',
      meta: {
        title: '车辆轨迹'
      },
      component: CarTrack
    },
    {
      path: '/car/gzjjAddress',
      name: 'GzjjAddress',
      meta: {
        title: '广州交警路段'
      },
      component: GzjjAddress
    },
    {
      path: '/dslOpenApiSign',
      name: 'DslOpenApiSign',
      meta: {
        title: '签名'
      },
      component: DslOpenApiSign
    },
    {
      path: '/dslApiGatewaySign',
      name: 'DslApiGatewaySign',
      meta: {
        title: '签名'
      },
      component: DslApiGatewaySign
    },
    {
      path: '/dslCreateJiraTask',
      name: 'DslCreateJiraTask',
      meta: {
        title: 'jira任务'
      },
      component: DslCreateJiraTask
    },
  ]
})


//对每次访问之前都要先看是否已经登录
router.beforeEach((to,from,next)=>{
  if(to.path.startsWith('/login')){
    window.localStorage.removeItem('x-auth-token');
    next();
  }else{
    let token = window.localStorage.getItem('x-auth-token');
    if(!token){
      //未登录  跳回主页面
      next({path:'/login'});
    }else{
      if (to.path === '/') {
        next({ path: '/home' })
      } else {
        console.log(to)
        // 修改页面标题
        if (to.meta.title) {
          document.title = to.meta.title;
        } else {
          document.title = '管理后台';
        }
        next();
      }
    }
  }
});

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router




// WEBPACK FOOTER //
// ./src/router/index.js